<div nz-flex [nzVertical]="true" [nzJustify]="'center'" [nzAlign]="'center'" [nzGap]="'middle'">
  <div class="header-wrapper">
    <h1>Zmiana hasła eWUŚ / Kolce</h1>
    <form nz-form nzLayout="vertical" class="create-form">
      <div nz-row [nzGutter]="[24, 0]">
        <div nz-col [nzXs]="24" [nzSm]="24">
          <nz-form-item>
            <nz-form-label nzRequired> Stare hasło </nz-form-label>

            <nz-form-control
              [nzValidateStatus]="
                changePasswordForm.oldPassword().invalid() &&
                (changePasswordForm.oldPassword().touched() ||
                  submitted() ||
                  changePasswordForm.oldPassword().dirty())
                  ? 'error'
                  : ''
              "
            >
              <input
                nz-input
                placeholder="np. Centrum Medyczne XYZ"
                [formField]="changePasswordForm.oldPassword"
                [nzStatus]="changePasswordForm.oldPassword().invalid() ? 'error' : ''"
              />
              <app-field-error
                [control]="changePasswordForm.oldPassword()"
                [submitted]="submitted()"
              ></app-field-error>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row [nzGutter]="[24, 0]">
        <div nz-col [nzXs]="24" [nzSm]="24">
          <nz-form-item>
            <nz-form-label nzRequired> Nowe hasło </nz-form-label>

            <nz-form-control
              [nzValidateStatus]="
                changePasswordForm.newPassword().invalid() &&
                (changePasswordForm.newPassword().touched() ||
                  submitted() ||
                  changePasswordForm.newPassword().dirty())
                  ? 'error'
                  : ''
              "
            >
              <input
                nz-input
                placeholder="np. Centrum Medyczne XYZ"
                [formField]="changePasswordForm.newPassword"
                [nzStatus]="changePasswordForm.newPassword().invalid() ? 'error' : ''"
              />
              <app-field-error
                [control]="changePasswordForm.newPassword()"
                [submitted]="submitted()"
              ></app-field-error>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
    <div class="button-footer-wrapper">
      <button
        nz-button
        nzType="primary"
        (click)="submit()"
        [nzLoading]="isLoading()"
        [disabled]="isLoading()"
      >
        <span nz-icon nzType="reload"></span>
        Zmień hasło
      </button>
    </div>
  </div>
</div>
